import { computed, Directive, inject, InjectionToken, Injector, Provider, Type } from '@angular/core';
import { ProductComponentBase } from '../ProductComponentBase';

@Directive()
export abstract class ProductHostComponentBase extends ProductComponentBase {
  private readonly _injector = inject(Injector);

  private readonly _productTypeComponentsToken = computed(() => (this.productType() ? this._componentTokens[this.productType()!] : null));
  protected readonly productTypeComponents = computed(() => {
    const token = this._productTypeComponentsToken();
    if (!token) return [];
    const components = this._injector.get(token, []);
    const result = Array.isArray(components) ? components.filter((comp) => comp != null) : [];
    return result;
  });

  protected readonly typeComponentInjector = computed(() => {
    return Injector.create({
      providers: [] as Provider[],
      parent: this._injector,
    });
  });

  protected readonly ready = computed(() => {
    return (
      !!this.typeComponentInjector() &&
      !!this.productTypeComponents() &&
      !this.productStore.productDetails.loading() &&
      !!this.productStore.productDetails()
    );
  });

  constructor(private _componentTokens: { [key: string]: InjectionToken<Type<unknown>[]> }) {
    super();
  }
}
